@let observedFilteredItems = filteredItems();

<div class="marg-browser wrapper">
	<calao-filter-bar (onFilterValuesChange)="onFilteredConversationsChanged($event.title)">
		<calao-filter-bar-main-content>
			<calao-filter-bar-item key="title">
				<ng-template let-observableValue="observableValue">
					<div class="search-input-container">
						<calao-filter-bar-search-input placeholder="Rechercher..." [value]="observableValue.value$ | async"
							(onValueChange)="observableValue.value = $event">
						</calao-filter-bar-search-input>
						@if ((observableAdvancedOptions.length$| async) !== 0) {
						<div class="advanced-options">
							<ion-icon size="large" name="ellipsis-vertical" (click)="presentAdvancedOptions($event)"></ion-icon>
						</div>
						}
					</div>
				</ng-template>
			</calao-filter-bar-item>
		</calao-filter-bar-main-content>
	</calao-filter-bar>

	@if (conversationTypeEnabled.length !== 1) {
	<div>
		@for (conversationType of conversationTypeEnabled; track conversationType) {
		<calao-conversation-sub-type-toggle [conversationType]="conversationType"
			[isFill]="conversationTypeFilteredSignal().includes(conversationType)"
			(click)="switchConversationTypeEnabled(conversationType)">
		</calao-conversation-sub-type-toggle>
		}
	</div>
	}

	@if (observedFilteredItems.length === 0) {
	<div class="synchro-container">
		<ion-note class="synchro-label">Aucune conversation.</ion-note>
	</div>
	}

	@if (observedFilteredItems.length > 0) {
	<div class="marg-container container">
		<calao-virtual-scroll autosize margeLastItem [itemSizeRemSignal]="5" [items]="observedFilteredItems"
			[trackBy]="trackByConversationRev">
			<ng-template let-item="$implicit">
				<calao-conversation-list-item [userJoinDateByGroupId]="userJoinDateByGroupId()"
					[conversation]="item.conversation" [activity]="item.userActivity" [userContactPath]="userContactPath"
					[conversationTypeEnabled]="conversationTypeEnabled" [disabled]="params()?.swipeDisabled"
					[participants]="item.participants" [userContactId]="userContactId" [canDelete]="canDelete"
					(onItemClicked)="onItemClicked($event)" (onAvatarClicked)="onAvatarClicked(item, $event)"
					(onDeleteClicked)="onConversationDelete($event)" (onArchiveClicked)="onConversationArchiveClicked($event)"
					(onRestoreClicked)="onConversationRestoreClicked($event)" (onSwiped)="onSwipe($event)"
					(onSlidingItemButtonOptionClicked)="onSlidingItemButtonOptionClicked($event)">
				</calao-conversation-list-item>
			</ng-template>
		</calao-virtual-scroll>
	</div>
	}
</div>

@if (!hideFabButton()) {
<ion-fab vertical="bottom" horizontal="end" slot="fixed" class="fab-margin">
	<ion-fab-button size="large" color="primary" (click)="onCreateConversationClicked()">
		<ion-icon name="add"></ion-icon>
	</ion-fab-button>
</ion-fab>
}